import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Form, Input } from 'antd'

const Item = Form.Item

export default class RoleAdd extends Component {

    // 基礎通用參數 //////////////////////////////////////////////   

    static propTypes = {
        setForm: PropTypes.func.isRequired
    }

    fm = React.createRef();
    UNSAFE_componentWillMount() {
        this.props.setForm(this.fm)
    }

    /////////////////////////////////////////////////////////////
        
    render() {
        const formItemLayout = {
            labelCol: { span: 4 },
            wrapperCol: { span: 15 }
        }
        return (
            <div>
                <Form ref={this.fm}>
                    <Item
                        {...formItemLayout}
                        label="角色名稱"
                        name="roleName"
                        rules={[
                            { required: true, whitespace: true, message: '必須輸入角色名稱' },
                        ]}
                    >
                        <Input placeholder="角色名稱" />
                    </Item>
                </Form>
            </div>
        )
    }
}